import type { IUserRole } from '@/types/user'
import { USER_ROLES } from '@/lib/constants/users'
export const USERS = {
  ROLES: {
    [USER_ROLES.ADMIN]: 'Admin',
    [USER_ROLES.CONSULTANT]: 'Consultant',
    [USER_ROLES.CONSULTANT_ADMIN]: 'Consultant Admin',
    [USER_ROLES.VIEWER]: 'Viewer',
    [USER_ROLES.EDITOR]: 'Editor',
    [USER_ROLES.AUDITOR]: 'Auditor',
    [USER_ROLES.MDM_EDITOR]: 'MDM Editor',
    [USER_ROLES.SUPPLIER]: 'Supplier',
  } satisfies Record<IUserRole, string>,
}
